import React from "react";
import style from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { ExerciseProps } from "../../../../../../../API/exercise";
import moment from "moment";

interface HeaderProps {
    headerData: ExerciseProps;
}

export default function Header({ headerData }: HeaderProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <div className={style.left}>
                    <h1 className={style.title}>
                        <Tooltip
                            title={headerData.description}
                            placement="bottomLeft">
                            <span>{headerData.description}</span>
                        </Tooltip>

                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    <div className={style.info}>
                        {headerData.validityTime && (
                            <span>
                                {" "}
                                活动时长&nbsp;&nbsp;{headerData.validityTime}
                                &nbsp;&nbsp;分钟&nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                            </span>
                        )}
                        {!headerData.validityTime && (
                            <span>
                                活动时长&nbsp;&nbsp;不限
                                &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                            </span>
                        )}
                        开始时间{" "}
                        {moment(headerData.startTime).format("MM-DD HH:mm")}{" "}
                        &nbsp; 结束时间{" "}
                        {moment(headerData.endTime).format("MM-DD HH:mm")}
                    </div>
                </div>
            </div>
        </div>
    );
}
